import ArchiveIcon from '@material-ui/icons/Archive';
import BlockIcon from '@material-ui/icons/Block';
import BorderColorIcon from "@material-ui/icons/BorderColor";
import DeleteIcon from "@material-ui/icons/Delete";
import DoneIcon from '@material-ui/icons/Done';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PublishIcon from '@material-ui/icons/Publish';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import VisibilityIcon from "@material-ui/icons/Visibility";


const CAN_READ = "canRead";
const CAN_UPDATE = "canUpdate";
const CAN_DELETE = "canDelete";
const CAN_APPROVE_STAGE_I = "canApproveStageI";
const CAN_APPROVE_STAGE_II = "canApproveStageII";
const CAN_DISAPPROVE_STAGE_I = "canDisapproveStageI";
const CAN_DISAPPROVE_STAGE_II = "canDisapproveStageII";
const CAN_PUBLISH = "canPublish";
const CAN_UNPUBLISH = "canUnPublish";
const CAN_ARCHIVE = "canArchive";


export const permissionNames = {
    CAN_READ,
    CAN_UPDATE,
    CAN_DELETE,
    // CAN_APPROVE_STAGE_I,
    // CAN_APPROVE_STAGE_II,
    // CAN_DISAPPROVE_STAGE_I,
    // CAN_DISAPPROVE_STAGE_II,
    // CAN_ARCHIVE,
    // CAN_PUBLISH,
    // CAN_UNPUBLISH,
}

export const permissionForRoles = (() => {
    let object = {};
    Object.values(permissionNames).map((each) => {
        object[each] = 1
    });
    return object;
})();

export const permissionIcons = {
    [CAN_READ]: {
        Icon: (props) => (<VisibilityIcon fontSize={"small"} {...props} />),
        title: "View",
    },
    [CAN_UPDATE]: {
        Icon: (props) => (<BorderColorIcon fontSize={"small"} {...props} />),
        title: "Update",

    },
    [CAN_DELETE]: {
        Icon: (props) => (<DeleteIcon fontSize={"small"} {...props} />),
        title: "Delete",
    },
    [CAN_APPROVE_STAGE_I]: {
        Icon: (props) => (<DoneIcon fontSize={"small"} {...props} />),
        title: "Approve For Stage I",
    },
    [CAN_APPROVE_STAGE_II]: {
        Icon: (props) => (<DoneAllIcon fontSize={"small"} {...props} />),
        title: "Approve For Stage II",
    },
    [CAN_DISAPPROVE_STAGE_I]: {
        Icon: (props) => (<BlockIcon fontSize={"small"} {...props} />),
        title: "Disapprove For Stage I",
    },
    [CAN_DISAPPROVE_STAGE_II]: {
        Icon: (props) => (<HighlightOffIcon fontSize={"small"} {...props} />),
        title: "Disapprove For Stage II",
    },
    [CAN_ARCHIVE]: {
        Icon: (props) => (<ArchiveIcon fontSize={"small"} {...props} />),
        title: "Archive",
    },
    [CAN_PUBLISH]: {
        Icon: (props) => (<PublishIcon fontSize={"small"} {...props} />),
        title: "Publish",
    },
    [CAN_UNPUBLISH]: {
        Icon: (props) => (<RemoveCircleOutlineIcon fontSize={"small"} {...props} />),
        title: "Unpublish",
    },
}

export const stateValuesByAction = {
    [CAN_ARCHIVE]: "-4",
    [CAN_DISAPPROVE_STAGE_II]: "-3",
    [CAN_DISAPPROVE_STAGE_I]: "-2",
    [CAN_APPROVE_STAGE_I]: "2",
    [CAN_APPROVE_STAGE_II]: "3",
    [CAN_UNPUBLISH]: "0",
    [CAN_PUBLISH]: "1",
}

export const permissionForEachRole = {
    // Admin
    "0": {
        [CAN_READ]: 1,
        [CAN_UPDATE]: 1,
        [CAN_DELETE]: 1,
        
        [CAN_ARCHIVE]: 1,
        [CAN_DISAPPROVE_STAGE_II]: 1,
        [CAN_DISAPPROVE_STAGE_I]: 1,
        [CAN_APPROVE_STAGE_I]: 1,
        [CAN_APPROVE_STAGE_II]: 1,
        [CAN_UNPUBLISH]: 1,
        [CAN_PUBLISH]: 1,
    },
    // User
    "1": {
        [CAN_READ]: 1,
        [CAN_UPDATE]: 1,
        [CAN_DELETE]: 1,
        
        [CAN_ARCHIVE]: 1,
        [CAN_DISAPPROVE_STAGE_II]: 1,
        [CAN_DISAPPROVE_STAGE_I]: 1,
        [CAN_APPROVE_STAGE_I]: 1,
        [CAN_APPROVE_STAGE_II]: 1,
        [CAN_UNPUBLISH]: 1,
        [CAN_PUBLISH]: 1,
    },
    // Prod
    "2": {
        [CAN_READ]: 1,
        [CAN_UPDATE]: 1,
        [CAN_DELETE]: 0,
        
        [CAN_ARCHIVE]: 0,
        [CAN_DISAPPROVE_STAGE_II]: 0,
        [CAN_DISAPPROVE_STAGE_I]: 0,
        [CAN_APPROVE_STAGE_I]: 0,
        [CAN_APPROVE_STAGE_II]: 0,
        [CAN_UNPUBLISH]: 0,
        [CAN_PUBLISH]: 0,
    },
}
